import { BehaviorSubject, Observable } from 'rxjs';
import { FeatureType, FeatureTypes, ModuleGroups } from '../../enums/module';
import { IModule } from './module';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ModulesService {
  private enabledModulesSubject = new BehaviorSubject<IModule[]>(null);
  enabledModules$ = this.enabledModulesSubject.asObservable();
  private enabledFeaturesSubject = new BehaviorSubject<FeatureType[]>(null);
  enabledFeatures$ = this.enabledFeaturesSubject.asObservable();

  constructor(private http: HttpClient) {}

  getCompanyModules(): Observable<IModule[]> {
    return this.http.get<IModule[]>(
      `:API_BASE_URLcompany/modules?enabled=true`
    );
  }

  professionalServicesModule: IModule = {
    name: ModuleGroups.PROFESSIONAL_SERVICES,
    features: [{ name: FeatureTypes.ACCOUNTING_SERVICE, enabled: true }],
    solutions: [],
  };

  init(): Observable<FeatureType[]> {
    return this.getCompanyModules().pipe(
      map((modules) => {
        const allModules = [
          ...(modules || []),
          this.professionalServicesModule,
        ];
        const features = allModules
          .flatMap((module) => module.features)
          .map((feature) => feature.name);

        this.enabledFeaturesSubject.next(features);
        this.enabledModulesSubject.next(allModules);
        return features;
      })
    );
  }

  isFeatureEnabled(feature: FeatureType): boolean {
    return this.enabledFeaturesSubject.value.includes(feature);
  }
}
